import script from "./PortalAnalyticsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalAnalyticsSection.vue?vue&type=script&setup=true&lang=js"

import "./PortalAnalyticsSection.vue?vue&type=style&index=0&id=2ffb912a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffb912a"]])

export default __exports__